import { gray80 } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var inputText = {
    '& .ag-cell-inline-editing': {
        '& input[class^=ag-][type=text]': {
            backgroundColor: gray80,
            '&:focus': {
                border: "".concat(rem(2), " solid var(--yds-ag-cell-edit-border-color)"),
            },
        },
    },
};
